/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NouvelleRouteImport } from './routes/nouvelle'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PvTaskIdRouteImport } from './routes/pv.$taskId'
import { Route as PvTaskIdStepRouteImport } from './routes/pv.$taskId.$step'

const NouvelleRoute = NouvelleRouteImport.update({
  id: '/nouvelle',
  path: '/nouvelle',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PvTaskIdRoute = PvTaskIdRouteImport.update({
  id: '/pv/$taskId',
  path: '/pv/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const PvTaskIdStepRoute = PvTaskIdStepRouteImport.update({
  id: '/$step',
  path: '/$step',
  getParentRoute: () => PvTaskIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/nouvelle': typeof NouvelleRoute
  '/pv/$taskId': typeof PvTaskIdRouteWithChildren
  '/pv/$taskId/$step': typeof PvTaskIdStepRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/nouvelle': typeof NouvelleRoute
  '/pv/$taskId': typeof PvTaskIdRouteWithChildren
  '/pv/$taskId/$step': typeof PvTaskIdStepRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/nouvelle': typeof NouvelleRoute
  '/pv/$taskId': typeof PvTaskIdRouteWithChildren
  '/pv/$taskId/$step': typeof PvTaskIdStepRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login' | '/nouvelle' | '/pv/$taskId' | '/pv/$taskId/$step'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/login' | '/nouvelle' | '/pv/$taskId' | '/pv/$taskId/$step'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/nouvelle'
    | '/pv/$taskId'
    | '/pv/$taskId/$step'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  NouvelleRoute: typeof NouvelleRoute
  PvTaskIdRoute: typeof PvTaskIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/nouvelle': {
      id: '/nouvelle'
      path: '/nouvelle'
      fullPath: '/nouvelle'
      preLoaderRoute: typeof NouvelleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pv/$taskId': {
      id: '/pv/$taskId'
      path: '/pv/$taskId'
      fullPath: '/pv/$taskId'
      preLoaderRoute: typeof PvTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pv/$taskId/$step': {
      id: '/pv/$taskId/$step'
      path: '/$step'
      fullPath: '/pv/$taskId/$step'
      preLoaderRoute: typeof PvTaskIdStepRouteImport
      parentRoute: typeof PvTaskIdRoute
    }
  }
}

interface PvTaskIdRouteChildren {
  PvTaskIdStepRoute: typeof PvTaskIdStepRoute
}

const PvTaskIdRouteChildren: PvTaskIdRouteChildren = {
  PvTaskIdStepRoute: PvTaskIdStepRoute,
}

const PvTaskIdRouteWithChildren = PvTaskIdRoute._addFileChildren(
  PvTaskIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  NouvelleRoute: NouvelleRoute,
  PvTaskIdRoute: PvTaskIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
